module.exports = __webpack_public_path__ + "img/f2e70cc3072ff225e9c6d456a4bbaee5.png";